import "./ProjectsCompetitions.module.css";
import Header from "@/reusable_sections/Header";
import CompetitionsHero from "./sections/CompetitionsHero";
import CompetitionEcosystem from "./sections/CompetitionEcosystem";
import Gallery from "./sections/Gallery";
import RoboticsArena from "./sections/RoboticsArena";
import CompetitionPrep from "./sections/CompetitionPrep";
import Comparison from "./sections/Comparison";
import EcosystemBridge from "./sections/EcosystemBridge";
import WhatParentsCanObserve from "./sections/WhatParentsCanObserve";
import CompetitionExperience from "./sections/CompetitionExperience";
import Consultation from "./sections/Consultation";
import RoboticsPathwayConnection from "./sections/RoboticsPathwayConnection";
import WhoItsForStartingPoint from "./sections/WhoItsForStartingPoint";
import Footer from "@/reusable_sections/Footer";
export default function ProjectsCompetitionsPage() {
  return <div>
      <Header />
      <CompetitionsHero id="competitions-hero" />
      <CompetitionEcosystem />
      <Gallery />
      <RoboticsArena />
      <CompetitionPrep />
      <Comparison />
      <EcosystemBridge id="competition-learning-connector" />
      <WhatParentsCanObserve />
      <CompetitionExperience />
      <WhoItsForStartingPoint />
      <Consultation />
      <RoboticsPathwayConnection />
      <Footer />
    </div>;
}